"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authGiftCardIntegrationContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const c = (0, core_1.initContract)();
exports.authGiftCardIntegrationContract = c.router({
    getGiftCardRedeemUrl: {
        method: 'GET',
        path: '/gift-card/redeem-url',
        query: zod_1.z.object({
            prizeOrderProductId: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.string(),
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
}, {
    pathPrefix: '/auth',
    baseHeaders: zod_1.z.object({
        'x-access-token': zod_1.z.string(),
    }),
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=giftCardIntegration.auth.contract.js.map